import { Dialog, DialogContent, DialogTitle, Box, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useThemeMode } from '../../lib/themes/ThemeProvider';

interface AboutDialogProps {
  open: boolean;
  onClose: () => void;
}

export function AboutDialog({ open, onClose }: AboutDialogProps) {
  const { mode } = useThemeMode();
  const logoSrc = mode === 'dark' ? '/ediphor-logo-light.svg' : '/ediphor-logo.svg';
  const buildDate = new Date(__BUILD_DATE__).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        About
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1} sx={{ pb: 2 }}>
          <Box
            component="img"
            src={logoSrc}
            alt="Ediphor"
            sx={{ height: 40 }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            LabCloud
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Version {__APP_VERSION__}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Built {buildDate}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            © {new Date(__BUILD_DATE__).getFullYear()} Ediphor
          </Typography>
        </Box>
        <Button variant="text" fullWidth onClick={onClose}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
}
